export const VERSION = '4.3.2-gogreen';
export const GIT_HASH = 'ecf5ff83806b90c0dda3ea2a11669c78ed4ae756';
export const BUILD_DATE = '';
export const CLIENT_BRAND = 'gg';
